import axios from 'axios'
import { dispatch } from 'd3';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';

const getDefaultStateForAuth = () => {
  return {
    user: null,
    access_token: localStorage.getItem("access_token"),
    auth_user:{},
    approval_requests:[],
    dashboard_summary:{
      cards:[],
      quotations:[]
    }
  }
}

const state = getDefaultStateForAuth()

// const state = {
//   user: null,
//   access_token: localStorage.getItem("access_token"),
//   auth_user:{}
// }

const getters = {
  user: state => state.user,
  access_token: state => state.access_token,
  auth_user: state => state.auth_user
}

const mutations = {
  RESET_STATE_FOR_AUTH (state) {
    Object.assign(state, getDefaultStateForAuth())
  },
  FETCH_ALL(state, data){
    state.approval_requests = data
  },
  SAVE_AUTH(state, data) {
    state.access_token = data.access_token
    state.user = data
  },
  LOGOUT(state) {
    state.user = null
    state.access_token = null
    localStorage.removeItem("access_token")
    localStorage.removeItem("user")
  },
  FETCH_AUTH_USER(state, data){
    state.auth_user = data
  },
  DASHBOARD_SUMMARY(state, data){
    state.dashboard_summary = data
  }
}

const actions = {
  fetchDashboardSummary({ commit }, data) {
    return axios.post(apiRoutes['DASHBOARD_SUMMARY'], data, authHeader())
        .then(response => {
          if(response.data.code == 1)
          {
            commit('DASHBOARD_SUMMARY', response.data.data)
          } else {
            commit('DASHBOARD_SUMMARY', [])
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response)
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem Querying Data!", error);
          }
      });
  },
  fetchApprovalRequests({ commit }, data) {
    return axios.post(apiRoutes['GET_APPROVAL_REQUESTS'], data, authHeader())
        .then(response => {
          if(response.data.code == 1)
          {
            commit('FETCH_ALL', response.data.data)
          } else {
            commit('FETCH_ALL', [])
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response)
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem Querying Data!", error);
          }
      });
  },
  resetState({ commit, dispatch }, payload) {
    commit("RESET_STATE_FOR_AUTH")
  },
  saveAuth({ commit, dispatch }, payload) {
    if(payload){
      localStorage.setItem("access_token", payload.access_token)
      localStorage.setItem("user", JSON.stringify(payload.user))
      commit("SAVE_AUTH", payload)
    }
   },
   getAuthUser({ commit }, data) {
    return axios.post(apiRoutes['GET_AUTH_USER'], data, authHeader())
        .then(response => {
          if(response.data.code == 1)
          {
            commit('FETCH_AUTH_USER', response.data.data)
          } 
          else 
          {
            commit('FETCH_AUTH_USER', {})
          }
        })
        .catch(error => {
          if (error.response) {
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem Querying Data!", error);
          }
      });
},
   async logout({ commit, dispatch }) {
    try 
    {
      //await axios.post(logout)
      //dispatch('action2', {}, { root: true })
      dispatch("bankAccounts/resetState", {}, { root: true })
      dispatch("countries/resetState", {}, { root: true })
      dispatch("currencies/resetState", {}, { root: true })
      dispatch("customers/resetState", {}, { root: true })
      dispatch("documentPrintouts/resetState", {}, { root: true })
      dispatch("employees/resetState", {}, { root: true })
      dispatch("notifications/resetState", {}, { root: true })
      dispatch("productBom/resetState", {}, { root: true })
      dispatch("productCodes/resetState", {}, { root: true })
      dispatch("productMedias/resetState", {}, { root: true })
      dispatch("products/resetState", {}, { root: true })
      dispatch("productUoms/resetState", {}, { root: true })
      dispatch("salechannels/resetState", {}, { root: true })
      dispatch("sales/resetState", {}, { root: true })
      dispatch("taxes/resetState", {}, { root: true })

    } 
    catch (e) { }

    commit("LOGOUT")
  },
}

export {
  state,
  getters,
  actions,
  mutations
}
